import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Facebook, Instagram, Youtube } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#12060a]">
      <div className="mx-auto max-w-6xl px-4 py-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="mb-4 flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-500 via-brand-400 to-rose-500 text-lg font-bold text-white">
                SM
              </div>
              <span className="text-lg font-semibold text-white">Auto Shazam</span>
            </div>
            <p className="text-sm text-white/60">
              Premium mobile detailing for the Greater Toronto Area. We bring water, power, and
              precision to every driveway appointment.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            <h3 className="mb-4 text-lg font-semibold text-white">Contact</h3>
            <div className="space-y-3 text-sm text-white/70">
              <a
                href="tel:+16475550147"
                className="flex items-center gap-2 transition hover:text-white"
              >
                <Phone className="h-4 w-4 text-brand-300" />
                (647) 555-0147
              </a>
              <a
                href="mailto:hello@shazam-detailing.ca"
                className="flex items-center gap-2 transition hover:text-white"
              >
                <Mail className="h-4 w-4 text-brand-300" />
                hello@shazam-detailing.ca
              </a>
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-brand-300" />
                Greater Toronto Area
              </div>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <h3 className="mb-4 text-lg font-semibold text-white">Quick Links</h3>
            <div className="space-y-2 text-sm text-white/70">
              <a href="/services" className="block transition hover:text-white">
                Packages & Pricing
              </a>
              <a href="/gallery" className="block transition hover:text-white">
                Project Gallery
              </a>
              <a href="/contact" className="block transition hover:text-white">
                Request A Detail
              </a>
              <a href="/contact#approval" className="block transition hover:text-white">
                Owner Approval Flow
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            <h3 className="mb-4 text-lg font-semibold text-white">Follow us</h3>
            <div className="flex gap-3">
              {[
                { Icon: Facebook, href: 'https://facebook.com' },
                { Icon: Instagram, href: 'https://instagram.com' },
                { Icon: Youtube, href: 'https://youtube.com' },
              ].map(({ Icon, href }) => (
                <a
                  key={href}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white/70 transition hover:border-white/40 hover:text-white"
                >
                  <Icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </motion.div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-6 text-sm text-white/60">
          <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
            <p>© {currentYear} Auto Shazam. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="/privacy" className="transition hover:text-white">
                Privacy Policy
              </a>
              <a href="/terms" className="transition hover:text-white">
                Terms of Service
              </a>
              <a href="mailto:hello@shazam-detailing.ca" className="transition hover:text-white">
                Partner with us
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
